import React, { useRef } from "react";
import CardCarousel from "../../../../components/CardCarousel/CardCarousel";
import HeadPage from "../../../../components/HeadPage/HeadPage";
import ButtonWithIcon from "../../../../components/ButtonWithIcon/ButtonWithIcon";
import { fetchData } from "../../../../fetcher";
import TheMallOutletLayout from "../../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../../../styles/pages/specific-experience.module.scss";
import ScrollDown from "../../../../components/ScrollDown/ScrollDown";

const ExperienceDetailPage = ({ menuItems, dataContent }) => {
  let mainContent = dataContent.experience.content;
  const scrollTo = useRef(null);

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head">
        <HeadPage scrollToRef={scrollTo} {...dataContent?.head} />
      </div>
      <div
        ref={scrollTo}
        className={`smallerCenteredSection ${styles.mainContent}`}
      >
        {mainContent.map((d, i) => (
          <div key={"specific-brand-" + i}>
            <div className={styles.title}>{d.title}</div>
            <div
              className={styles.paragraph}
              dangerouslySetInnerHTML={{ __html: d.paragraph }}
            ></div>
            <div className={styles.detailsContainer}>
              {d.details &&
                d.details.map((l, j) => (
                  <div key={"specific-brand-detail-" + i + "-" + j}>
                    <span className={styles.detailTitle}>{l.name + " "}</span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: l.value.replace("<p>", "").replace("</p>", ""),
                      }}
                      className={styles.value}
                    ></span>
                  </div>
                ))}
            </div>
          </div>
        ))}
        <div className={styles.link}>
          <ButtonWithIcon
            link={dataContent.experience.booking.link}
            outline={false}
          />
        </div>
        <div
          className={styles.buttonParagraph}
          dangerouslySetInnerHTML={{
            __html: dataContent.experience.booking.paragraph,
          }}
        ></div>
      </div>
      {dataContent.experienceCarousel.items.length > 0 && <div className={styles.CardCarousel}>
        <CardCarousel
          listOfBrands={dataContent.experienceCarousel.items}
          goldTitle={dataContent.experienceCarousel.goldTitle}
          hoverText={dataContent.experienceCarousel.hoverText}
          autoplay={false}
        />
      </div>}
      <div className="scroll">
        <ScrollDown selector={scrollTo} scrollTop />
      </div>
    </TheMallOutletLayout>
  );
};

ExperienceDetailPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default ExperienceDetailPage;
